import { eMucThuTamThuActionsObj } from "../../action-types/muc-thu/IMucThuTamThuActionTypes";
import { generateActions } from "../generateActions";

export const mucThuTamThuActions = {
  ...generateActions(eMucThuTamThuActionsObj, "MUC_THU_TAM_THU"),
};
